import './applied_hashtag_view.js.coffee';# Added by Script 
class Monitoring.Views.SocialContents.Filters.AppliedPostHashtagView extends Monitoring.Views.SocialContents.Filters.AppliedHashtagView
  alias: 'Hashtags'
  name: 'post_hashtags'

  removeFilter: (value) ->
    @searchQuery.removePostHashtag(value)
